import { useTuiServiceStore } from './store';
/**
 * The functions in this module are provided for the case when
 * the calling code is outside of React.
 *
 * The preferred way to register callout element targets is via the provided hooks.
 */
export var updateTuiTargetElementData = function (elementId, data) {
    return useTuiServiceStore.getState().updateTuiTargetElementData(elementId, data);
};
//# sourceMappingURL=unreactive.js.map